import React from "react";
import ItemDetailsFooter from "./item-details-footer";

const ItemDetailsShareItem = ({ itemInfo }) => {
  console.log(itemInfo);
  return (
    <div className="item-details-body-container">
      <p className="home-logo-container">
        <img src={require("../../../assets/images/logo.png")} alt="logo" />
      </p>
      <div className="item-details-share-item-body">
        <div className="item-details-share-item-wrapper">
          <div className="item-details-share-user-info-container">
            <img src={itemInfo.user.avatar} alt="user" />
            <div>
              <p>{itemInfo.user.name}</p>
              <p>would like to share this item with you.</p>
            </div>
          </div>
          <div className="item-details-share-item-item-info-container">
            <img src={itemInfo.item.image} alt="item" />
            <div className="item-details-share-item-item-info-container-text">
              <p>{itemInfo.item.name}</p>
              <p>{itemInfo.item.description}</p>
              {itemInfo.item?.variations &&
              itemInfo.item.variations?.length > 0 ? (
                <p>
                  {itemInfo.item.variations?.length} price variations available
                </p>
              ) : (
                <p>${parseFloat(itemInfo.item.price).toFixed(2)}</p>
              )}
            </div>
          </div>
        </div>
        <ItemDetailsFooter text="Please download the app to receive this item." />
      </div>
    </div>
  );
};

export default ItemDetailsShareItem;
